import { useLayoutEffect, useState } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';

interface ItemType {
    text: string;
    link: string;
}
const FP: React.FC = () => {
    const INIT_PROCESS: number = 100;
    const { t } = useLang('dpux');
    const [enter, setEnter] = useState<boolean>(false);
    const [active, setActive] = useState<number>(0);
    const [process, setProcess] = useState<number>(INIT_PROCESS);

    const items: ItemType[] = [
        {
            text: t('Fix_Process1'),
            link: '#delta-pro-ultra-x-E',
        },
        {
            text: t('Fix_Process2'),
            link: '#delta-pro-ultra-x-J',
        },
        {
            text: t('Fix_Process3'),
            link: '#delta-pro-ultra-x-O',
        },
        {
            text: t('Fix_Process4'),
            link: '#delta-pro-ultra-x-Q',
        },
        {
            text: t('Fix_Process5'),
            link: '#delta-pro-ultra-x-Tabs',
        },
        {
            text: t('Fix_Process6'),
            link: '#delta-pro-ultra-x-App',
        },
    ];

    const handleArchor = (item: ItemType) => {
        const anchorDom: HTMLElement | null = document.querySelector(item.link);
        if (anchorDom) {
            // 当前滚动距离
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            window.sessionStorage.setItem('toTop-scrollTop', scrollTop.toString());
            anchorDom.scrollIntoView({
                behavior: 'smooth',
            });
        }
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: 'none',
            button_name: item.text,
            __btn_id1: css.section,
            __btn_id2: item.text,
        });
    };

    useLayoutEffect(() => {
        if (typeof window !== 'undefined') {
            const sceneArr: any = [];
            const timer = setTimeout(() => {
                // 这个得看是不是需要控制出现的时机
                sceneArr.push(
                    AniContainer.create({
                        triggerElement: '.delta-pro-ultra-x .overview .delta-pro-ultra-x-C',
                        triggerHook: 1,
                        offset: '50%',
                        duration: '10000%',
                        onEnter: () => setEnter(true),
                        onLeave: () => setEnter(false),
                    }),
                );

                const rangeArr: string[] = ['range1', 'range2', 'range3', 'range4', 'range5', 'range6'];
                rangeArr.forEach((range: string, k: number) => {
                    const rangeDom: HTMLDivElement | null = document.querySelector(`.delta-pro-ultra-x .overview .${range}`);
                    if (rangeDom) {
                        const rangeH: number = Number(rangeDom.offsetHeight);
                        sceneArr.push(
                            AniContainer.create({
                                triggerElement: rangeDom,
                                triggerHook: 0,
                                offset: -200,
                                duration: rangeH,
                                onEnter: () => setActive(k),
                                onProcess: (rate: number) => setProcess(100 * (1 - rate)),
                            }),
                        );
                    }
                });
            }, 3000);

            return () => {
                clearTimeout(timer);
                sceneArr.forEach((item: any) => item.destroy());
            };
        }
    }, []);

    return (
        <div className={`fix-process ${css.section} ${enter ? 'enter' : ''}`}>
            {items?.map((item: ItemType, k: number) => (
                <span className={`pro-item GtmModuleData-btn-text ${active === k ? 'active' : ''}`} onClick={() => handleArchor(item)}>
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                        <circle cx="16" cy="16" r="16" fill="none" stroke="#444444" strokeWidth="8"></circle>
                        <circle
                            cx="16"
                            cy="16"
                            r="16"
                            fill={k === active ? 'none' : '#444444'}
                            stroke="white"
                            strokeWidth="8"
                            strokeDashoffset={k === active ? process : '100'}
                            strokeLinecap="round"
                            strokeDasharray="100"
                        ></circle>
                    </svg>

                    <span className="item-name">{item.text}</span>
                </span>
            ))}
        </div>
    );
};

export default FP;
